import i18n from 'i18next';

i18n.init({
  lng: 'de',
  fallbackLng: 'de',
  resources: {
    de: {
      translation: {
        locale: 'de',
        backDowncased: 'zurück',
        back: 'Zurück',
        shareThisPage: 'Diese Seite teilen',
        calendar: 'Kalender',
        share: 'Teilen',
        contact: 'Kontakt',
        print: 'Drucken',
        bookmark: 'Merken',
        bookmarkAlert1: 'Tastenkombination',
        bookmarkAlert2: 'um die Seite zu Ihren Lesezeichen hinzuzufügen',
        noEvents: 'Aktuell keine Veranstaltungen in',
        eventsIn: 'Veranstaltungen in',
        visitRepresentativeOffice: 'Besuchen Sie auch unsere Repräsentanz in',
        linkRepresentativeOffice: 'Zur Repräsentanz'
      }
    },
    en: {
      translation: {
        locale: 'en',
        backDowncased: 'back',
        back: 'Back',
        shareThisPage: 'Share this page',
        calendar: 'Calendar',
        share: 'Share',
        contact: 'Contact',
        print: 'Print',
        bookmark: 'Bookmark',
        bookmarkAlert1: 'Key combination',
        bookmarkAlert2: 'to add this page to you bookmarks',
        noEvents: 'Currently no events in',
        eventsIn: 'Events in',
        visitRepresentativeOffice: 'Visit our representative office in',
        linkRepresentativeOffice: 'Open representative office'
      }
    }
  }

  // uncomment the following two lines for debug statements in the console
  // ,
  // debug: true
});

export default i18n;



// WEBPACK FOOTER //
// ./i18n.js